//React components 
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
//Components 
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ErrorAlert from '../Alerts/ErrorAlert';
import LoadingAlert from '../Alerts/LoadingAlert';
import { Container } from 'react-bootstrap';
import { RenderIf } from '../utils/RenderIf';
import { PreOrderFetchAPI } from '../../api/Paymentpost/PreOrder';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import { PowetranzFetchAPI } from '../../api/Powertranz';
import { DeletedTempOrdersFetchAPI } from '../../api/DeletedTemporalOrders';
import { MachinesFetchAPI } from '../../api/Machines';
import { OrderNumberFetchAPI } from '../../api/OrderNumber';
import { Modal, Button } from 'react-bootstrap';
import DocPdf from '../Pdf/DocPdf';
import {buildCloudinaryImageUrl} from '../utils/CloudinaryImageUrl';


const OrderDetailPreOrder = ({ orderData, userBranchoffices, handlerUpdatePreOrder, handleCloseModal, statusDetailModalDinamic, branchOfficeData }) => {
    const [newBranchoffice, setNewBranchoffice] = useState({});
    const { business_code } = useParams()
    const [formatVoucher, setformatVoucher] = useState("");
    const [modalShowVoucher, setmodalShowVoucher] = useState(false)

    //Total taxes 
    const [totalTaxes, setTotalTaxes] = useState([
        { total_base: 0, tax: "0%", total_tax: 0 },
        { total_base: 0, tax: "7%", total_tax: 0 },
        { total_base: 0, tax: "10%", total_tax: 0 },
        { total_base: 0, tax: "15%", total_tax: 0 }
    ]);

    const handleViewCoucher = () => {
        formatVoucherString()
        setmodalShowVoucher(true)
    }

    //-----------------------POWERTRANZ FUNCTIONS -----------------------//
    //Void powertranz
    const voidPowertranz = async () => {

        let order_code = orderData.code
        let dataPowetranz = orderData.powertranz
        LoadingAlert("Anulando pago...", "Por favor espere mientras se procesa la anulacion del pago...");
        console.log(dataPowetranz.TransactionIdentifier || dataPowetranz.powertranzResponse.TransactionIdentifier);
        try {
            let token = localStorage.getItem('x-access-token')
            console.log(dataPowetranz.TransactionIdentifier || dataPowetranz.powertranzResponse.TransactionIdentifier);
            let data = { "TransactionIdentifier": dataPowetranz.TransactionIdentifier || dataPowetranz.powertranzResponse.TransactionIdentifier }
            console.log("data", data);

            let headers = {
                'x-access-token': token,
                'X-PowerTranz-Id': dataPowetranz?.X_PowerTranz_Id,
                'X-PowerTranz-Password': dataPowetranz?.X_PowerTranz_Password,
            }
            const response = await PowetranzFetchAPI.void(data, headers);
            let approved = response.data.data.Approved;
            let responseVoidData = dataPowetranz
            responseVoidData.powertranzResponse = response.data.data

            let datafilter = response.data.data
            const now = new Date(); // Gets current date and time
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}/${(now.getMonth() + 1).toString().padStart(2, '0')}/${now.getFullYear()}`;
            const formattedTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
            responseVoidData.voucher = `\r\n        ***  POWERTRANZ  ***        \r\n\r\n        ***  ANULADO  ***        \r\n\r\nOrden:                       ${datafilter.OrderIdentifier.split("X")[0]}\r\nDATE: ${formattedDate}            ${formattedTime}\r\n\r\nDESCRIPTION:\r\n   ${datafilter.ResponseMessage}\r\nTOTAL:                      ${datafilter.TotalAmount} \r\n\r\n        ***  ANULADO  ***        \r\nSTATUS:                     APROVADO\r\nAUTH:                       ${datafilter.AuthorizationCode}\r\nTXID:\r\n${datafilter.TransactionIdentifier}\r\n\n           ****** FIN  ******            \r\n`;
            let newVoucher = { EMVStreamResponse: responseVoidData }
            if (approved == true) {
                deleteTempPreOrder(order_code, responseVoidData, true)
            } else {
                refundPowertranz()
            }

        } catch (err) {
            ErrorAlert("No se aplico la devlucion.", "Error en la devolucion", "error")
            console.log(err);
        }
    }

    //Refund powertranz
    const refundPowertranz = async () => {
        let order_code = orderData.code
        let dataPowetranz = orderData.powertranz
        try {
            let token = localStorage.getItem('x-access-token')
            let data = { "TransactionIdentifier": dataPowetranz?.TransactionIdentifier || dataPowetranz?.powertranzResponse?.TransactionIdentifier }

            let headers = {
                'x-access-token': token,
                'X-PowerTranz-Id': dataPowetranz?.X_PowerTranz_Id,
                'X-PowerTranz-Password': dataPowetranz?.X_PowerTranz_Password
            }
            const response = await PowetranzFetchAPI.refund(data, headers);
            let approved = response.data.data.Approved;
            let responseVoidData = dataPowetranz
            responseVoidData.powertranzResponse = response.data.data

            let datafilter = response.data.data
            const now = new Date(); // Gets current date and time
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}/${(now.getMonth() + 1).toString().padStart(2, '0')}/${now.getFullYear()}`;
            const formattedTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
            responseVoidData.voucher = `\r\n        ***  POWERTRANZ  ***        \r\n\r\n        ***  ANULADO  ***        \r\n\r\nOrden:                       ${datafilter.OrderIdentifier.split("X")[0]}\r\nDATE: ${formattedDate}            ${formattedTime}\r\n\r\nDESCRIPTION:\r\n   ${datafilter.ResponseMessage}\r\nTOTAL:                      ${datafilter.TotalAmount} \r\n\r\n        ***  ANULADO  ***        \r\nSTATUS:                     APROVADO\r\nAUTH:                       ${datafilter.AuthorizationCode}\r\nTXID:\r\n${datafilter.TransactionIdentifier}\r\n\n           ****** FIN  ******            \r\n`;
            let newVoucher = { EMVStreamResponse: responseVoidData }
            if (approved == true) {
                deleteTempPreOrder(order_code, newVoucher, true)
            }
        } catch (err) {
            ErrorAlert("No se aplico la devlucion.", "Error en la devolucion", "error")
            console.log(err);
        }
    }

    //delete pre order true
    const deleteTempPreOrder = async (temporal_orden_code, newVoucher, statusDeleted, transaction_code, orden_code) => {

        let token = localStorage.getItem('x-access-token');
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'));
        let branch_code = branchoffice.code

        let jsonUpdate = {
            "order_code": temporal_orden_code,
            "business_code": business_code,
            "branchoffice_code": branch_code,
        }

        console.log(newVoucher);
        if (newVoucher !== undefined && newVoucher !== null) {
            console.log("entre aqui");
            jsonUpdate.justification = "Orden rechazada"
            jsonUpdate.EMVStreamResponse = newVoucher
        }

        if (statusDeleted == true) {
            jsonUpdate.deleted = true
            jsonUpdate.status = 5
        } else {
            jsonUpdate.deleted = false
            jsonUpdate.status = 3
            jsonUpdate.finished_order_transaction_code = transaction_code
            jsonUpdate.finished_order_code = orden_code
        }

        try {
            await DeletedTempOrdersFetchAPI.newDeletedTempOrder(jsonUpdate, token);
            const response = await PreOrderFetchAPI.deletePreOrder(jsonUpdate, token)
            handleCloseModal();
            handlerUpdatePreOrder();
            if (statusDeleted == true) {
                ErrorAlert("Precuenta a sido rechazada.", "La orden se rechazo con exito.", "success")
            }


        } catch (err) {
            console.log(err);
        }

    }

    const capturePowertranz = async (TotalAmount) => {
        LoadingAlert("Capturando pago...", "Por favor espere mientras se procesa la captura del pago...");
        let order_code = orderData.code
        let dataPowetranz = orderData.powertranz

        try {
            let token = localStorage.getItem('x-access-token')
            let data = { "TransactionIdentifier": dataPowetranz.TransactionIdentifier, "TotalAmount": TotalAmount }
            let headers = {
                'x-access-token': token,
                'X-PowerTranz-Id': dataPowetranz?.X_PowerTranz_Id,
                'X-PowerTranz-Password': dataPowetranz?.X_PowerTranz_Password
            }



            const response = await PowetranzFetchAPI.capture(data, headers);
            let dataTemp = {}
            dataTemp.X_PowerTranz_Password = dataPowetranz?.X_PowerTranz_Password;
            dataTemp.X_PowerTranz_Id = dataPowetranz?.X_PowerTranz_Id;
            dataTemp.X_PowerTranz_BaseUrl = dataPowetranz?.X_PowerTranz_BaseUrl
            dataTemp.TransactionIdentifier = dataPowetranz?.TransactionIdentifier
            dataTemp.powertranzResponse = response.data.data
            let datafilter = response.data.data


            if (datafilter?.Approved == true) {

                const now = new Date(); // Gets current date and time
                const formattedDate = `${now.getDate().toString().padStart(2, '0')}/${(now.getMonth() + 1).toString().padStart(2, '0')}/${now.getFullYear()}`;
                const formattedTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
                dataTemp.voucher = `\r\n        ***  POWERTRANZ  ***        \r\n\r\nOrden:                       ${datafilter.OrderIdentifier.split("X")[0]}\r\nDATE: ${formattedDate}            ${formattedTime}\r\n\r\nDESCRIPTION:\r\n   ${datafilter.ResponseMessage}\r\nTOTAL:                      ${datafilter.TotalAmount} \r\n\r\nPAYMENT METHOD:             ${datafilter.CardBrand}\r\nSTATUS:                     APROVADO\r\nAUTH:                       ${datafilter.AuthorizationCode}\r\nTXID:\r\n${datafilter.TransactionIdentifier}\r\n\n           ****** FIN  ******            \r\n`;
                lastOrderMachineRequest(dataTemp)
                ErrorAlert("Pago capturado con exito.", "La orden se aprobo con exito.", "success")
            } else {
                ErrorAlert("No se capturo el pago.", "Error en la captura del pago", "error")
            }
        } catch (err) {
            ErrorAlert("No se capturo el pago.", "Error en la captura del pago", "error")
            console.log(err);
        }
    }

    //-----------------------END POWERTRANZ FUNCTIONS -----------------------//

    //-----------------------REGISTER FUNCTIONS -----------------------//
    const [registerTurnOrder, setRegisterTurnOrder] = useState(0);
    //get last order in this machine
    const lastOrderMachineRequest = async (newVoucher) => {
        let token = localStorage.getItem('x-access-token');
        try {
            const response = await MachinesFetchAPI.lastOrderMachine(orderData.machine_id, token);
            getOrderNumber(response.data.last_order._id, newVoucher)
        } catch (err) {
            console.log(err)
        }
    }

    // get order number in process
    const getOrderNumber = async (lastOrder_id, newVoucher) => {
        let token = localStorage.getItem('x-access-token');
        try {
            const response = await OrderNumberFetchAPI.getOrderNumber(orderData?.branchoffice?.id || 0, token)
            let orderNumber = (parseInt(response.data.last_transaction_code) + 1)
            registernewOrder(newVoucher, lastOrder_id, orderNumber)
        } catch (err) {
            console.log(err);
        }
    }

    //function register order

    const registernewOrder = async (detailEMVStreamResponse, lastOrder_id, orderNumber) => {

        let token = localStorage.getItem('x-access-token')
        LoadingAlert("Registrando orden...", "Espere un momento por favor...")

        //We check if the order is not registered
        if (registerTurnOrder == 0) {
            let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
            let machine = JSON.parse(localStorage.getItem('machine'));
            let json = {
                "user_id": 0,
                "EMVStreamResponse": detailEMVStreamResponse,
                "transaction_code": orderNumber,
                "client_name": orderData.client_name,
                "client_id": orderData.client_id,
                "ruc": orderData.client_ruc,
                "dv": orderData.client_dv,
                "localizador": "00",
                "client_phone": orderData.client_phone,
                "dgi_qr": "0",
                "Orden": orderData.groups,
                "combos": orderData.combos,
                "Descuento": orderData.discount,
                "Total": orderData.total,
                "itbms": orderData.tax,
                "tips": orderData.tips || 0,
                "taxes": orderData.taxes,
                "direction": orderData.direction,
                "subtotal": orderData.subtotal,
                "machine_id": orderData.machine_id,
                "branchoffice_id": orderData?.branchoffice?.id || 0,
                "tipoOrden": orderData.order_type,
                "paymethod": orderData.paymenthod_id,
                "paymethods": [],
                "discounts": orderData.discounts,
                "paymenthod_integration_id": orderData.paymenthod_integration_id !== undefined ? orderData.paymenthod_integration_id : 0,
                "parthner_order": false,
            }


            try {
                const response = await OrderNumberFetchAPI.registerOrder(json, token)
                ErrorAlert("Orden registrada con exito", "Orden generada", "success")
                setRegisterTurnOrder(1);
                //SuccessAlert("Orden registrada con exito", "Orden generada", "success")
                deleteTempPreOrder(orderData.code, undefined, false, response.data.data.transaction_code, response.data.data.order_code)


                /*const tieneReserva = shoppingcart.find(item => ,item.type === "reservable");
                //We check if the delivery rule is asap to send the order to asap
                if (selectedDeliveryRule != null && selectedDeliveryRule != undefined) {
                    if (selectedDeliveryRule.fee_type === "kilometer" && selectedDeliveryRule.distance_source != null && selectedDeliveryRule.distance_source === "asap") {
                        try {
                            await registerAsapOrder(response.data.data.order_id)
                        } catch (err) {
                            console.log(err)
                        }
                    }
                }
                // Retorna true si existe al menos una reserva, false si no
                if (tieneReserva) {
                    // Si hay reservas, se ejecuta esta lógica
                    putOrderReservedCode(response.data.data.order_code, response.data.data.id_order, tieneReserva)
                } else {
                    AlertSmall("Orden registrada con exito", "success")
                    navigate(`/order/${response.data.data.order_code}`);
                }


                clearShoppingCartlocalStorage();*/
            } catch (err) {
                //valid to id of transaction

                /*if (err.response.data.error === "La máquina está ocupada. Intenta en unos segundos.") {

                    setRegisterTurnOrder(0)
                    //ErrorAlert("", err.response.data.error, "error")
                    alertOption()

                } else {
                    try {
                        let token = localStorage.getItem('x-access-machine-token');
                        const response = await MachinesFetchAPI.lastOrderMachine(machine.id, token);

                        if (response.data.last_order._id == lastOrder_id) {

                            setRegisterTurnOrder(0)
                            //ErrorAlert("", "Ocurrio un error", "error")
                            alertOption()
                        } else {
                            setDataTransaction_code(response.data.last_order.transaction_code);
                            setOrder_id(response.data.last_order.order_id)
                            setOrderCode(response.data.last_order.order_code)
                            setRegisterTurnOrder(1);
                            ErrorAlert("Orden registrada con exito", "Orden generada", "success")
                            //navigate(`/order/${response.data.data.order_code}/branchoffice/${branchoffice.id}/${business_code}/${branchoffice_code}/${machine_code_table}`);
                          

                        }
                    } catch (err) {
                        console.log(err)
                    }
                }


                function alertOption() {
                    Swal.fire({
                        title: err.response.data.error,
                        text: "¡Intenta de nuevo el resgistro en un momento!",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Intentar de nuevo",
                        cancelButtonText: "No, intentar de nuevo"
                    }).then((result) => {
                        if (result.isConfirmed) {
                            registernewOrder(detailEMVStreamResponse, paymentInfo)
                        }
                    });
                }*/
            }
        } else {
            console.log("Hay una orden en proceso");
        }



    }
    //-----------------------------------------------------------------------//

    //Function to populate the users branch 
    const branchList = () => {
        const listBracnh = userBranchoffices.map((branch) => (
            <>
                <option value={JSON.stringify(branch)}>{branch.branchoffice_name}</option>
            </>
        ));
        return listBracnh
    }

    //put preOrder change branchoffice
    const updatePreOrder = async () => {
        if (newBranchoffice != "0") {
            let token = localStorage.getItem('x-access-token')
            let dataBranchoffice = JSON.parse(newBranchoffice);
            try { 

                const responseBranchOffice = await BranchOfficeFetchAPI.getBranchOfficesByid(dataBranchoffice.branchoffice_id, token);
                let dataResponseBranchoffice = responseBranchOffice.data.data.branchoffice;
                let data = {
                    "_id": orderData._id,
                    "groups": orderData.groups,
                    "branchoffice": {
                        "id": dataResponseBranchoffice.branchoffice_id,
                        "code": dataResponseBranchoffice.code,
                        "name": dataResponseBranchoffice.name,
                        "ruc": dataResponseBranchoffice.ruc,
                        "dv": dataResponseBranchoffice.dv
                    }
                }

                const response = await PreOrderFetchAPI.updateOrderTempPreOrder(data, token)
                handleCloseModal();
                handlerUpdatePreOrder();
                ErrorAlert("", "Se asigno la precuenta a la otra sucursal", "success")

            } catch (err) {
                ErrorAlert('', 'Lo sentimos ocurrio un error', 'error');
                console.log(err);
            }
        } else {
            ErrorAlert('', 'Debes seleccionar una sucursal', 'info');
        }

    }

    //We charge the items of the order 
    const orderItems = () => {
        let items = orderData.groups.map((product) => (
            <div className="d-flex text-muted pt-3 px-xs-2" key={product._id}>
                <img className="bd-placeholder-img flex-shrink-0 me-2 rounded" loading="lazy" src={buildCloudinaryImageUrl({url: product.img, width: 300, quality: "auto", type: "image"})} width="42" height="42" />
                <div className="pb-3 mb-0  lh-sm  w-100">
                    <div className="d-flex justify-content-between ">
                        {/* Name */}
                        <span className="text-dark fw-bold">{product.name}</span>
                        {/* Cantidad/ Quantity*/}
                        <div>
                            <span className='px-3 label-card'>x {product.amount} </span>
                            <label className="fw-bold text-dark" translate='no'>$ {product.price.toFixed(2)}</label>
                        </div>

                    </div>
                    {/** Segment items */}
                    <>

                        {product.segments.map((segments) => (
                            <div className="d-flex justify-content-between" key={segments._id}>
                                {/* item name */}
                                <span className=" label-card">{segments.item.name}</span>
                            </div>
                        ))}

                        <div className='mt-2'>
                            <div>
                                <span className='label-card p-1' >
                                    Entrega: {product.delivery_type}
                                </span>
                            </div>
                            <div>
                                <RenderIf isTrue={product.note != ""}>
                                    <small className='text-danger p-1' >
                                        Nota: {product.note}
                                    </small>
                                </RenderIf>
                            </div>
                        </div>




                    </>
                </div>
            </div>
        ));
        return <>{items}</>
    }

    // funtion convert format voucher
    const formatVoucherString = () => {
        console.log("DATA DEL VOUCHER");

        let kinposVoucher = null
        if (orderData.bank_voucher_response) {
            try {
                let dataVoucher = JSON.parse(orderData.bank_voucher_response)
                if (dataVoucher.voucher) kinposVoucher = dataVoucher.voucher
            } catch (err) { console.log(err) }
        }

        let voucher = kinposVoucher || orderData.voucher_response || ""
        // Extraer el número de tarjeta ocultando los dígitos intermedios
        const maskedVoucher = voucher.replace(/(\d{6})\d+(\d{4})/g, "$1XXXXXX$2");

        // Construir el string formateado del voucher
        const formattedVoucher = `${maskedVoucher}`;
        setformatVoucher(formattedVoucher)
    };

    return (<>


        <div className='position-relative'>
            <div className='position-absolute top-0 start-100 translate-middle mt-2 '>
                <div className='me-3'>
                    <button class="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1" type="button" title='Cerrar'
                        onClick={() => handleCloseModal()}

                    >
                        <i class="uil uil-multiply"></i>
                    </button>
                </div>
            </div>

            <h2 className="title-main-login  text-center ">
                <i class="uil uil-receipt-alt" translate='no'></i>
                Detalles de Precuenta
            </h2>
            <div className='mx-3 flex-column mb-2'>

                <div className='header-modal-info-pre-order '>
                    <div className='border-dashed  d-flex flex-wrap gap-3 rounded-3 p-0 my-2 p-2'>
                        <div>
                            <span className="text-success">
                                <span className="text-secondary">
                                    <i class="uil uil-receipt-alt"></i> Orden:
                                </span>
                            </span>
                            <span className="fw-bold"> # {orderData.transaction_code ? orderData.transaction_code : 0}</span>
                        </div>

                        <div className='text-black'>
                            <span className="text-secondary">
                                <i class="uil uil-user-circle"></i> Cliente:
                            </span>
                            <span className="fw-bold"> {!orderData.client_name ? "No Registrado" : orderData.client_name}</span>
                        </div>

                        <div className='text-black'>
                            <span className="text-secondary">
                                <i class="uil uil-location-pin-alt"></i> Modo de entrega:
                            </span>
                            <span className="fw-bold"> {orderData.order_type}</span>
                        </div>
                        <span className="text-nowrap text-black h6 d-block">


                            <span className="text-secondary">
                                <i class="uil uil-store"></i> Sucursal:
                            </span> {orderData.branchoffice?.name || ""}
                        </span>

                        <span className="text-nowrap text-black h6 d-block">
                            <i className="fa-solid fa-cash-register"></i>


                            <span className="text-secondary">
                                <i className="fa-solid fa-store"></i> Usuario:
                            </span> {orderData.machine_name} {!orderData.user ? 'No es cajera' : orderData.user.name}
                        </span>
                        <RenderIf isTrue={orderData.is_evertech_pay}>
                            <div className='text-black'>
                                <span className="text-secondary">
                                    <i class="uil uil-money-bill"></i> Pago:
                                </span>
                                <span className="fw-bold"> {orderData.is_evertech_pay && orderData.evertech_transaction_status === "PENDING" ? "Pago pendiente de aprobacion, procesado por placetopay" : orderData.evertech_transaction_status}</span>
                            </div>
                        </RenderIf>
                        {orderData.paymentInfo ? <>
                            {orderData.paymentInfo.map((payment) => (
                                <span className="text-nowrap text-dark h6 d-block">

                                    <span className="text-secondary">
                                        <i className="fa-solid fa-store"></i> Método de pago:
                                    </span> {payment.name}
                                </span>
                            ))}</> : <></>}
                    </div>
                </div>

                <div className='main-modal-info-pre-order'>
                    <div className='row '>
                        <div className='col-12 col-md-8  rounded-3'>
                            <div className=' border-dashed rounded-3 p-2'>
                                <div className='d-flex justify-content-between border-bottom fw-bold label-card mt-2 '>

                                    <span>Producto</span>

                                    <span>Precio</span>

                                </div>
                                {/* Item cards */}
                                {orderItems()}

                                <div className='overflow-auto '>
                                    {orderData.deleted_code && <div className='p-2 border-dashed rounded-3 mt-2'>
                                        <h6 className="fw-bold">
                                            Tipo de eliminación
                                        </h6>
                                        <div className='d-flex justify-content-around'>
                                            {orderData.deleted_code == "USER_REQUEST" ? <>
                                                <span className={`fw-bold text-danger ms-1`}><i class="uil uil-user-nurse"> Eliminado por usuario</i></span>
                                            </> : <>{orderData.deleted_code == "UNION_PAY" ? <>
                                                <span className={`fw-bold text-primary ms-1`}><i class="uil uil-compress-arrows"> Union de precuentas</i></span>
                                            </> : <>{orderData.deleted_code == "DIVIDED_BILL" ? <>
                                                <span className={`fw-bold text-primary ms-1`}><i class="uil uil-arrows-resize"> Division de precuentas</i></span>
                                            </> : <>
                                                <span className={`fw-bold text-warning ms-1`}><i class="uil uil-question-circle"></i></span>
                                            </>}
                                            </>}</>}

                                        </div>
                                    </div>}
                                    <RenderIf isTrue={orderData.justification}>

                                        <p className='text-center'><small className='text-danger p-1 ' >
                                            Justificacion: {orderData.justification}
                                        </small></p>


                                    </RenderIf>
                                </div>
                            </div>

                        </div>
                        <div className='col-12 col-md-4 mt-lg-0 mt-2'>
                            <div className=' border-dashed rounded-3 p-2'>
                                <div className='d-flex justify-content-between border-bottom fw-bold label-card mt-2'>
                                    <span>Detalles de orden</span>
                                </div>
                                <div className="flex-column gap-4 text-muted py-2 my-2 ">
                                    <div className="d-flex justify-content-between">
                                        <span className="text-secondary fw-normal"> Descuento: </span>
                                        <span className='text-dark fw-bold'>
                                            <span className='px-2 '>$</span>
                                            {orderData.discount.toFixed(2)}
                                        </span>
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <span className="text-secondary fw-normal"> Subtotal:  </span>
                                        <span className='text-dark fw-bold'>
                                            <span className='px-2 '>$</span>
                                            {orderData.subtotal.toFixed(2)}
                                        </span>
                                    </div>

                                    {orderData.taxes.map((tax) => (
                                        <>
                                            <div className="d-flex justify-content-between">
                                                <span className="text-secondary fw-normal"> Impuesto({tax.tax}):   </span>
                                                <span className='text-dark fw-bold'>
                                                    <span className='px-2 '>$</span>
                                                    {tax.total.toFixed(2)}
                                                </span>
                                            </div>
                                        </>
                                    ))}

                                    <div className="d-flex justify-content-between border-top">
                                        <span className="text-secondary fw-bold h4 mt-3"> Total:  </span>
                                        <span className='text-dark fw-bold h4 mt-3'>
                                            <span className='px-2 '>$</span>
                                            {orderData.total.toFixed(2)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='footer-modal-info-pre-order'>
                    {orderData.is_powertranz_pay == true ? <>

                        <div className='d-flex justify-content-between m-2'>
                            <button type="button" class="btn btn-warning" onClick={async () => voidPowertranz()} ><i class="uil uil-times-circle"></i> Rechazar</button>
                            <button type="button" class="btn btn-success" onClick={async () => capturePowertranz(orderData.total)}><i class="uil uil-check-circle"></i> Aprobar</button>
                        </div>
                    </> : <>
                        <RenderIf isTrue={statusDetailModalDinamic == true && (orderData.is_evertech_pay == false || orderData.is_evertech_pay == undefined)}>
                            <div className='d-flex justify-content-between mt-3'>
                                <span className="text-nowrap text-secondary h6 d-block">
                                    <div class="tooltip-container">
                                        <i class="uil uil-info-circle"></i>
                                        <span class="tooltip-text">Puedes reasignar la precuenta a una sucursal diferente.</span>
                                    </div>   Cambiar sucursal:
                                    <form className='filter-sp-trn'>
                                        <div className="d-block">
                                            <select className='form-select' name="user_branch" id="user_branch" onChange={(e) => setNewBranchoffice(e.target.value)}>
                                                <option value={0}> Seleccione una sucursal</option>
                                                {branchList()}
                                            </select>
                                        </div>
                                    </form>
                                </span>
                            </div>
                            <div className='text-end'>
                                <button type="button" class="btn btn-primary" onClick={async () => updatePreOrder()}  >Guardar</button>
                            </div>
                        </RenderIf></>}

                    {orderData.paymentInfo ?
                        <>
                            <PDFDownloadLink document={<DocPdf
                                doc_type={"invoice"} invoiceQR={orderData.dgi_qr} invoiceDate={orderData.createdAt} cufe={orderData.cufe} auth_protocol={orderData.auth_protocol ? orderData.auth_protocol : "00000000"}
                                receptor={{
                                    name: orderData.client_name,
                                    ruc: orderData.client_ruc,
                                    direction: "Panama",
                                    dv: orderData.client_dv,
                                }}
                                emitter={branchOfficeData}
                                products={orderData.groups} invoiceSubtotal={orderData.subtotal} totalTaxes={totalTaxes}
                                totalCashReceived={orderData.total} invoiceTotal={orderData.total} invoiceTotalItbms={orderData.tax} paymentMethod={orderData.paymenthod}
                                invoiceShipping={orderData.delivery?.value || 0}
                            />} >
                                <button className='btn btn-success  rounded-2 mt-2' > <i class="uil uil-file-download"></i>  Descargar Factura Electrónica </button>
                            </PDFDownloadLink>
                        </> : <></>}
                </div>
                {/**Voucher button */}
                <RenderIf isTrue={orderData.bank_voucher_response != "0"}>

                    <button class="btn bg-primary-subtle rounded-2 border-primary text-primary fw-bold"
                        onClick={() => (handleViewCoucher())} title="Actualizar Lista">
                        <i className="uil uil-receipt-alt "></i>
                        Voucher de transacción

                    </button>
                </RenderIf>
            </div >
        </div>

        <Modal
            show={modalShowVoucher}
            onHide={() => setmodalShowVoucher(false)}
            centered>
            <Modal.Header>
                Voucher de transaccion: #{orderData.transaction_code}
            </Modal.Header>
            <Modal.Body>
                <div>
                    <pre>{formatVoucher}</pre>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => (setmodalShowVoucher(false))}>Cerrar</Button>
            </Modal.Footer>
        </Modal>

    </>);
}

export default OrderDetailPreOrder;